import React, { useEffect, useState } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Input } from 'antd';
import Button from '@iso/components/uielements/button';
import authAction from '@iso/redux/auth/actions';
import appAction from '@iso/redux/app/actions';
import Form from '@iso/components/uielements/form';
import SignInStyleWrapper from './SignIn.styles';
import Image from '@iso/components/utility/image';
import siteConfig from '@iso/config/site.config';

const FormItem = Form.Item;

const { login } = authAction;
const { clearMenu } = appAction;

function SignIn(props) {
  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.Auth.accessToken);
  const { profile } = useSelector((state) => state.Auth);
  const { getFieldDecorator } = props.form;
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      setRedirectToReferrer(true);
    }
  }, [isLoggedIn]);

  const handleLogin = async (e) => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        setLoading(true);
        dispatch(login(values));
        dispatch(clearMenu());
        setLoading(false);
        history.push('/dashboard');
      }
    });
  };

  let { from } = location.state || { from: { pathname: '/dashboard' } };

  if (redirectToReferrer) {
    return (
      <Redirect
        to={
          profile.role === 'bengkel'
            ? {
                pathname: '/dashboard/order-bengkel',
                state: { from: location }
              }
            : from
        }
      />
    );
  }
  return (
    <div>
      <SignInStyleWrapper className="isoSignInPage">
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <div className="isoLogoWrapper">
              <Image width="400" height="150" />
            </div>
            <div className="isoSignInForm">
              <Form onSubmit={handleLogin}>
                <div className="isoInputWrapper">
                  <FormItem hasFeedback>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          type: 'email',
                          message: 'Email tidak valid'
                        },
                        {
                          required: true,
                          message: 'Silahkan input email'
                        }
                      ]
                    })(<Input size="large" placeholder="Email" name="email" id="email" />)}
                  </FormItem>
                </div>
                <div className="isoInputWrapper">
                  <FormItem hasFeedback>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Silahkan input password'
                        }
                      ]
                    })(
                      <Input
                        size="large"
                        type="password"
                        placeholder="Password"
                        name="password"
                        id="password"
                      />
                    )}
                  </FormItem>
                </div>

                <div className="isoInputWrapper isoLeftRightComponent">
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Sign
                  </Button>
                  <p style={{ color: 'black', marginTop: '1em' }}>{siteConfig.footerText}</p>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </SignInStyleWrapper>
    </div>
  );
}
const WrapperSignForm = Form.create()(SignIn);
export default WrapperSignForm;
